<template>
  <div id="app">
    <header>
      <nav-bar></nav-bar>
    </header>
    <router-view/>
    <foot-bar></foot-bar>
    <cookie-law theme="blood-orange"></cookie-law>
  </div>
</template>

<script>

import NavBar from '@/components/navbar'
import FootBar from '@/components/footbar'
// Cookie Meldung
import CookieLaw from 'vue-cookie-law';

export default {
  name: 'App',
  components: {
    NavBar,
    FootBar,
    CookieLaw
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue